import DOMPurify from 'dompurify'
import { createNotificationsPlugin, NotificationsApi } from '@space/notifications'

import { httpClient, getApiBaseUrl } from '@/shared/api/httpClient'

const notificationsApi = new NotificationsApi(httpClient, {
  baseURL: getApiBaseUrl(),
})

export const notificationsPlugin = createNotificationsPlugin({
  api: notificationsApi,
  autoFetch: false, // Don't fetch until user is authenticated
  sanitizeHtml: (html) => DOMPurify.sanitize(html, {
    ADD_ATTR: ['target', 'class', 'tagName', 'size'],
    RETURN_TRUSTED_TYPE: false,
  }),
  formatDate: (value) => value,
})
